import GenericErrorImage from '@/assets/images/errors/generic.png';
import settings from '@/constants/constants';
import { Box, Link, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const ImageContainer = styled(Box)(({ theme }) => ({
  '& img': {
    width: '343px',
    [theme.breakpoints.up('sm')]: {
      width: '421px',
    },
  },
}));

function ExpiredLink() {
  return (
    <Stack gap={6} textAlign="center">
      <ImageContainer>
        <img src={GenericErrorImage} alt="" />
      </ImageContainer>
      <Typography variant="subtitle1">Looks like your onboarding link has expired</Typography>
      <Typography variant="body1">
        For security reasons, onboarding links are only <b>valid for 7 days</b>.
      </Typography>
      <Typography variant="body1">No worries, we&apos;re happy to send you a new one!</Typography>
      <Typography variant="body1">
        Simply email us at{' '}
        <b>
          <Link to={`mailto:${settings.support.email}`}>{settings.support.email}</Link>
        </b>{' '}
        <br />
        and we&apos;ll get it sorted for you.
      </Typography>
    </Stack>
  );
}

export default ExpiredLink;
